import { createApp } from "vue"
import upperFirst from "lodash/upperFirst"
import camelCase from "lodash/camelCase"

import * as Sentry from "@sentry/vue"

import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./index.css"

import stripe from "./store/stripe"

import Maska from "maska"
import { VueCookieNext } from "vue-cookie-next"
import vClickOutside from "click-outside-vue3"

import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

import Vue3DraggableResizable from "vue3-draggable-resizable"
import "vue3-draggable-resizable/dist/Vue3DraggableResizable.css"

import mitt from "mitt"
const emitter = mitt()

const app = createApp(App)

app.config.globalProperties.backendBaseUri = process.env.VUE_APP_BASE_URI || "http://localhost:8000"
app.config.globalProperties.supportEmail =
  process.env.VUE_APP_SUPPORT_EMAIL || "support@rentapplication.net"
app.config.globalProperties.stripePublishableKey =
  process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_dvrn6GRBfhCdtx4YUxUJ7x45"

app.config.globalProperties.stripe = stripe
app.config.globalProperties.showWelcomeModal = process.env.VUE_APP_WELCOME_MODAL_ENABLED === "true"
app.config.globalProperties.classicToggleEnabled = !!process.env.VUE_APP_CLASSIC_BASE_URI
app.config.globalProperties.grooveWidgetProspect = process.env.VUE_APP_GROOVE_WIDGET_PROSPECT
app.config.globalProperties.grooveWidgetLandlord = process.env.VUE_APP_GROOVE_WIDGET_LANDLORD
app.config.globalProperties.grooveWidgetApplicant = process.env.VUE_APP_GROOVE_WIDGET_APPLICANT
//app.config.globalProperties.sentryDSN = process.env.VUE_APP_SENTRY_DSN
//GROOVE_WIDGET, GROOVE_WIDGET_PROSPECT, GROOVE_WIDGET_LANDLORD, GROOVE_WIDGET_APPLICANT
//RSP_ALERT_ENABLED

app.config.globalProperties.$emitter = emitter
app.config.globalProperties.infoPageSlugs = router.options.routes
  .find((r) => r.name === "home_base")
  .children.map((r) => r.path.replace("/", ""))

app.config.globalProperties.baseHostName = location.origin
app.config.globalProperties.isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  window.innerWidth < 768
    ? true
    : false
//https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
const requireComponent = require.context(
  // The relative path of the components folder
  "./components",
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName)
  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  )
  // Register component globally
  app.component(componentName, componentConfig.default || componentConfig)
})

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: []
  })
}

app
  .use(Maska)
  .use(Vue3DraggableResizable)
  .use(VueCookieNext)
  .use(vClickOutside)
  .use(Toast, {
    // Can be either a string or an array of strings
    containerClassName: "rentapp-toast",
    icon: false,
    closeButton: false,
    hideProgressBar: true,
    timeout: 3000
  })
  .use(router)
  .use(store)
  .mount("#app")

VueCookieNext.config({ expire: "7d" })

// only available during E2E tests
if (window.Cypress) {
  window.app = app
}
